import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { Layout } from '@/components/layout/Layout';
import { SearchSection } from '@/components/search-section/SearchSection';
import { searchSeo } from '@/components/seo/searchSeo';
import { SEO } from '@/components/seo/SEO';

export const getStaticProps: GetStaticProps = async context => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale as string, ['common'])),
    },
  };
};

export default function Home() {
  return (
    <Layout>
      <SEO {...searchSeo} />
      <SearchSection />
    </Layout>
  );
}
